var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.227,
    height: 12.64,
    viewBox: "0 0 7.227 12.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M16.3,12.514,11.512,7.735a.9.9,0,0,1,0-1.276.911.911,0,0,1,1.28,0l5.419,5.415a.9.9,0,0,1,.026,1.246L12.8,18.573a.9.9,0,1,1-1.28-1.276Z",
    transform: "translate(-11.246 -6.196)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.d3b810b001d1fecf77177e48945d0d2e.svg";
export { ForwardRef as ReactComponent };